export default {
  forgot_password_submit: {
    title: 'Passwort zurücksetzen',
    submit_complete: 'Erfolgreich gesendet',
    password_reset: 'Passwort wurde zurückgesetzt',
  },
}
